import throttle from "lodash.throttle";
import Component from "@base/js/component";

export default class DataThreeUp extends Component {
  // Defines the element selector which will initialize this component
  static selector = ".data-three-up";

  // Defines children that needs to be queried as part of this component
  static children = {
    carousel: ".data-three-up-carousel", // Queries a single element
    leftControl: ".data-three-up-carousel__control[data-direction='left']",
    rightControl: ".data-three-up-carousel__control[data-direction='right']",
  };

  // Defines sub components that needs to be queried as part of this component
  static members = {
    // subComponent: ComponentClass, // Maps as a single subcomponent instance
    // subComponents: [ComponentClass], // Maps as an array of subcomponent instances
  };

  // Defines event handlers to attach to children
  eventHandlers = {
    leftControl: {
      click: () => this.onMove("left"),
    },
    rightControl: {
      click: () => this.onMove("right"),
    },
    carousel: {
      scroll: throttle(this.onCarouselScroll, 300),
    },
  };

  // constructor() {
  //   super();
  // }

  // Will be called upon component instantiation
  afterInit() {
    this.onCarouselScroll(); // initialize
  }

  /**
   * onMove.
   *
   * @param {string} direction: left | right
   * @return {any};
   */
  onMove(direction) {
    const { carousel } = this.children;

    const { scrollLeft, offsetWidth, scrollWidth } = carousel;
    const carouselItemWidth = carousel.children[0].offsetWidth;

    const isAtTheStart = scrollLeft <= 0;
    const isTheEndReached = scrollWidth <= scrollLeft + offsetWidth;

    switch (direction) {
      case "left": {
        if (isAtTheStart) return null;

        carousel.scrollTo({
          left: scrollLeft - carouselItemWidth,
          behavior: "smooth",
        });

        break;
      }

      case "right": {
        if (isTheEndReached) return null;

        carousel.scrollTo({
          left: scrollLeft + carouselItemWidth,
          behavior: "smooth",
        });

        break;
      }

      default:
        throw new Error("Invalid direction!");
    }
  }

  onCarouselScroll() {
    const { carousel, leftControl, rightControl } = this.children;

    const { scrollLeft, offsetWidth, scrollWidth } = carousel;

    const isAtTheStart = scrollLeft <= 0;
    const isTheEndReached = scrollWidth <= Math.ceil(scrollLeft) + offsetWidth;

    leftControl.disabled = false;
    rightControl.disabled = false;

    if (isAtTheStart) {
      leftControl.disabled = true;
    }

    if (isTheEndReached) {
      rightControl.disabled = true;
    }
  }
}

// Remove this line if this component is not intended
// to initialize on DOM load.
DataThreeUp.init();
